import React from "react";
import { useFormik } from "formik";
import { useQueryClient } from "@tanstack/react-query";
import { Toggle } from "../../../../../shared/Toggle/Toggle";
import classes from "../scss/PosSunbit.module.scss";
import { useChangeCapabilityStatus } from "../hooks/useChangeCapabilityStatus";
import { CircularProgress } from "../../../../../shared/CircularProgress/CircularProgress";
import { uiNotification } from "../../../../../services/UINotificationService";
import { QUERY_KEYS } from "../../../../../consts/api";
import StatusIcon from "./StatusIcon";

const Capability = ({ capability }) => {
  const { mutate, isLoading } = useChangeCapabilityStatus();
  const queryClient = useQueryClient();

  const { values, setFieldValue } = useFormik({
    initialValues: {
      isEnabled: capability.is_sunbit_enabled,
    },
  });

  const stripeStatus = capability.stripe.status;

  const handleToggle = () => {
    mutate(
      { isSunbitEnabled: !values.isEnabled, clinicId: capability.clinic_id },
      {
        onSuccess: (res) => {
          setFieldValue("isEnabled", !values.isEnabled);
          uiNotification.success(res.data.message);
          queryClient.setQueryData(
            [QUERY_KEYS.sunbit.getCapabilities],
            () => res,
          );
        },
        onError: (error) => {
          uiNotification.error(error.response.data.message);
        },
      },
    );
  };

  const getStatus = (clinicConfig) => {
    const showAuthorizedDate =
      clinicConfig["sunbit_modified"] &&
      clinicConfig["sunbit_modified"] !== "0000-00-00";
    let status = "disabled";

    if (clinicConfig.stripe.status === "active") {
      status = "enabled in Stripe";
    } else if (clinicConfig.stripe.status === "inactive") {
      status = "pending";
    }

    const date =
      status !== "pending" && showAuthorizedDate
        ? `(authorized on ${clinicConfig["sunbit_modified"]})`
        : "";

    return (
      <div className={classes.authorizationStatus}>
        Status: {status} {date}
      </div>
    );
  };

  return (
    <div className={classes.capabilityContainer}>
      <div className={classes.capability}>
        <span className={classes.capabilityTitle}>{capability.name}</span>
        {isLoading ? (
          <CircularProgress />
        ) : (
          <Toggle isEnabled={values.isEnabled} onChange={handleToggle} />
        )}
      </div>
      {}
      <div className={classes.capabilityStatus}>
        <StatusIcon capabilityStatus={stripeStatus} />
        {getStatus(capability)}
      </div>
    </div>
  );
};

export default Capability;
